import styles from "./GlobalButton.module.css";

const GlobalButton = ({
  children,
  variant = "primary",
  size = "large",
  leftIcon,
  rightIcon,
  isLoading = false,
  disabled = false,
  type = "button",
  ...props
}) => {
  const variantClasses = {
    primary: styles["button--primary"],
    warning: styles["button--warning"],
    secondary: styles["button--secondary"],
    tertiary: styles["button--tertiary"],
  };

  const sizeClasses = {
    large: styles["button--large"],
    medium: styles["button--medium"],
    small: styles["button--small"],
  };

  return (
    <button
      type={type}
      disabled={disabled || isLoading}
      className={`${styles.button} ${variantClasses[variant]} ${sizeClasses[size]}`}
      {...props}
    >
      {isLoading ? (
        <span className={styles.spinner} />
      ) : (
        <>
          {leftIcon && (
            <span className={styles["button__icon"]}>{leftIcon}</span>
          )}

          {children}

          {rightIcon && (
            <span className={styles["button__icon"]}>{rightIcon}</span>
          )}
        </>
      )}
    </button>
  );
};

export default GlobalButton;
